module.exports = __webpack_public_path__ + "img/photo-6.e68eb187.jpg";